import React from 'react'
import ReactTable from "react-table";
import Workbook from 'react-excel-workbook'
import { filterCaseInsensitive } from '../../../../utils/commonUtility'
import DotLoader from '../../Loader/DotLoader.component'
import { ROLE } from '../../../../utils/Constant';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Tooltip from '@mui/material/Tooltip';
import LogsInactive from '../../../../images/rewampimages/logsinactive.png'
import Pagination from '@mui/material/Pagination';
import { formatDateLatest } from '../../../../utils/commonUtility';
import CommunicationDetailPopupAllApplications from './CommunicationDetailPopupAllApplications';
import { ABHICASH_LIKE, CHECK_COMPANY_TENANT, Company_DATA } from '../../../../layouts/MainTenantconfig';
// import ExotelMain from '../../../containers/Admin/ExotelCall/MainCall'

const ApplicationStatus = ({ changeBucket, bucketType, statsData, formStatusList, handleStepChange, steps, CustomStepIcon, filterData, startDateToshow, endDateToshow, dateHandle, formStatus, statusHandler, paginationHandler, phocketTablePagination, tableMaxPagination, tableMinPagination, admin, allUserDetail, backpage, forwordpage, dataFilter,
    deleteUserHandler, isDeleteUser, editUserHandler, loadarState, unsubscribeHandler,
    getFilterValue, FilteredData, getPageValue, pageIndexToShow, varifyMobile, teaGardenData, teaGardenId, teaChangeHandler, commPopupData, handleCommLogsPopup, PopupbuttonHandle, PopupViewTab, AddCommentHandler, SaveCommentInPopup, commentData, communicationList, AddCallDetailHandler, SaveCallDetailInPopup, formStatusData, HandlePopupAddBtn, showPopupTabsValue, handlecommunicationDetailTypechange, communicationDetailType, handleLogListPopup, LogListPopup,handleResend,
    MarkAsImportant, RemarksType, handleRemarkType, RemarksListData, handleDownloadExcel, filterBox, handleSelectBoxValue, handlePreview, showCommServiceDataPreview, commList, GetCommunicationLogsMain, handlecommMain, tenant, HandlecallPopup, callPopup, ExcelDownloadData, handleDownloadExcelOption }) => (
    <div className="container-fluid">
        {/* <div className="row">
            <div className="col-xs-12">
                <h3 className="text-center blue-text">Application Status</h3>
            </div>
        </div> */}
        <div className='row'>
            <div className='col-sm-2 col-xs-12'>
                <label>Start Date</label>
                <input value={startDateToshow} onChange={(e) => dateHandle(e, 'start')} className='form-control' type='date' />
            </div>
            <div className='col-sm-2 col-xs-12'>
                <label>End Date</label>
                <input value={endDateToshow} onChange={(e) => dateHandle(e, 'end')} className='form-control' type='date' />
            </div>
            <div className='col-sm-1 col-xs-12'>
                <button className='btn btn-primary' onClick={() => filterData()} style={{ marginTop: '20px', padding: '10px' }}>Filter</button>
            </div>
            <div className='col-sm-4 col-xs-12'>
                <div className='row'>
                    <div className='col-sm-4 col-xs-12'>
                        <button className={bucketType === 'p1' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => changeBucket('p1')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Priority 1</button>

                    </div>
                    <div className='col-sm-4 col-xs-12'>
                        <button className={bucketType === 'p2' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => changeBucket('p2')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Priority 2</button>

                    </div>
                    <div className='col-sm-4 col-xs-12'>
                        <button className={bucketType === 'p3' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => changeBucket('p3')} style={{ marginTop: '20px', padding: '10px', width: '100%' }}>Priority 3</button>

                    </div>

                </div>
            </div>
            <div className='col-sm-3 col-xs-12' >
                {statsData !== '' ?
                <div style={{display:'flex',gap:'5px'}}>
                    <button className={bucketType === '' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => changeBucket('')} style={{ marginTop: '20px', padding: '10px', width: '100%',fontSize:'13px' }}>Total Counts : {statsData !== '' ? statsData?.totalCount : ""}</button>
                    <button className={bucketType === '' ? 'btn btn-primary' : 'btn btn-default'} onClick={() => changeBucket('')} style={{ marginTop: '20px', padding: '10px', width: '100%',fontSize:'13px' }}>Todays Counts : {statsData !== '' ? statsData?.todayCount : ""}</button>
                </div>

                    // <div
                    // onClick={() => changeBucket('')}
                    //     className='new-card-market shadow"'>
                    //     <div style={{ color: 'grey' }}> Total Counts : <b>{statsData !== '' ? statsData.totalCount : ""}</b></div><br />
                    //     {/* <b style={{ fontSize: '18px' }}></b> */}
                    // </div>
                    : ""}
            </div>
        </div>

        <div className="row form-group" style={{ marginTop: '20px' }}>
            {/* <div className="col-sm-2 col-xs-12">
                <label className="font-12px"><span className="fa fa-search" /> Email ID</label>
                <input type="email" className="form-control" onChange={e => dataFilter(e, "email")} />
            </div>
            <div className="col-sm-2 col-xs-12">
                <label className="font-12px" ><span className="fa fa-search" /> Mobile No.</label>
                <input type="number" onChange={e => dataFilter(e, "mobileNo")} className="form-control" />
            </div> */}
            <div className='col-sm-3 col-xs-12'>
                <label>Select Filter</label>
                <span className='main-search'>
                    <select className='form-control' style={{ background: "rgb(219, 233, 255)", fontWeight: "700", padding: '10px' }} value={filterBox} onChange={(e) => handleSelectBoxValue(e)}>
                        <option value={"email"}>Email</option>
                        <option value={"mobileNo"}>Mobile No.</option>
                        <option value={"name"}>Name</option>
                    </select>
                    <span className='main-search'>
                        {
                            filterBox == "email" ?
                                <input style={{ padding: '10px' }} type="email" onChange={e => dataFilter(e, "email")} placeholder='Search...' className='form-control' />
                                :
                                filterBox == "mobileNo" ?
                                    <input style={{ padding: '10px' }} type="number" onChange={e => dataFilter(e, "mobileNo")} placeholder='Search...' className='form-control' />
                                    :
                                    filterBox == "name" ?
                                        <input style={{ padding: '10px' }} type="text" onChange={e => dataFilter(e, "name")} placeholder='Search...' className='form-control' />
                                        :
                                        <input style={{ padding: '10px' }} type="text" onChange={e => dataFilter(e, "")} className='form-control' />
                        }
                    </span>
                </span>
            </div>
            {/* <div className='col-sm-2 col-xs-12'>
                <label>Select Tea Garden</label>
                <select className='form-control' value={teaGardenId} onChange={(e) => teaChangeHandler(e, 'teaGardenId')}>
                    <option value=''>Select Tea Garden</option>

                    {teaGardenData ? teaGardenData.map((data, i) => {
                        return (
                            <option value={data.teaGardenId}>{data.tea_garden_name}</option>

                        )
                    }) : ""}
                </select>
            </div> */}
            <div className='col-sm-2 col-xs-12'>
                <label>Select Form Status</label>
                <select className='form-control' value={formStatus} onChange={(e) => statusHandler(e)}>
                    <option value=''>Select Form Status</option>
                    {formStatusList.length > 0 &&  CHECK_COMPANY_TENANT(ABHICASH_LIKE) ?
                        formStatusList.map((data, i) => {
                            return (
                                <option value={data === "KYC Verification" ? "KycVerify" : data === "Employment Details" ? "EmploymentDetails" : data === "Documents" ? "UploadDocuments" : data === "Account Details" ? "PersonalDetails" : data === "Loan Details" ? "LoanApproval" : data == "Reference" ? "reference" : data}>{data}</option>
                            )
                        })


                        : ""}
                    {formStatusList.length > 0 && !CHECK_COMPANY_TENANT(ABHICASH_LIKE) ?
                        formStatusList.map((data, i) => {
                            return (
                                <option value={data}>{data}</option>
                            )
                        })


                        : ""}

                </select>
            </div>
            <div className="col-sm-2 col-xs-12">
                <label className="font-12px" ><span className="fa fa-search" />Employee Id</label>
                <input type="number" onChange={(e) => teaChangeHandler(e, 'employeeId')} className="form-control" />
            </div>
            <div className='col-sm-1 col-xs-12' style={{ marginTop: '22px' }}>
                {admin && admin.rolelist.indexOf(ROLE.DASHBOARD_REPORT_NEW) >= 0 ?
                    //                 <Workbook filename="ApplicationStatus.xlsx" element={<button className="profile-save-btn margin-0"><span className="fa fa-download"></span>&nbsp;&nbsp;Excel</button>}>
                    //                     <Workbook.Sheet data={allUserDetail} name="Sheet A">
                    //                         <Workbook.Column label="firstName" value="firstName" />
                    //                         <Workbook.Column label="emailId" value="emailId" />
                    //                         <Workbook.Column label="mobileNumber" value="mobileNumber" />
                    //                         <Workbook.Column label="panNumber" value="panNumber" />
                    //                         <Workbook.Column label="formStatus" value="formStatus" />
                    //                         <Workbook.Column label="Comment"value={row => row.comments?.[0] || "N/A"}
                    // />
                    //                     </Workbook.Sheet>
                    //                 </Workbook>
                    <button className="profile-save-btn margin-0" onClick={() => handleDownloadExcelOption(true, "show")}><span className="fa fa-download"></span>&nbsp;&nbsp;Excel</button>
                    : ""}
            </div>
            <div className="col-sm-3 col-xs-12" style={{ marginTop: '22px' }}>
                <button className="profile-save-btn margin-0" onClick={() => handleLogListPopup(true)}><i class="fa fa-eye" aria-hidden="true"></i>&nbsp;Communication Logs</button> &nbsp;
                {/* {
                    tenant?.COMPANY_NAME == Company_DATA?.ABHICASH ?
                        <button className="profile-save-btn margin-0" onClick={() => HandlecallPopup(true)}><i class="fa fa-phone" aria-hidden="true"></i></button>
                        : ''} */}
            </div>

        </div>
        <div className=" mui-ste" >
            <div className="shadow" style={{}}>
                <Box sx={{ width: '100%', marginTop: '50px' }}>
                    <Stepper alternativeLabel>
                        {steps.length > 0 ? steps.map((step, index) => {
                            const stepData = formStatusData[step?.label];
                            // const hasData = stepData && (stepData?.mail || stepData?.sms || stepData?.call);
                            const hasData = stepData && (stepData?.email || stepData?.sms || stepData?.whatsapp);
                            return (
                                <Step key={step.label} sx={{
                                    ".MuiStepLabel-iconContainer > div": {
                                        cursor: 'pointer',
                                        // backgroundColor: 'rgb(30, 176, 210) !important',
                                        "&:hover": {
                                            // borderRadius:'50%',
                                            backgroundColor: "#fff !important",
                                            border: "6px solid #267dff",
                                            color: '#267dff !important',
                                            transition: "all 0.2s ease-in"
                                        }
                                    }
                                }} onClick={() => handleStepChange(index)}>
                                    {stepData ? (
                                        <Tooltip placement="top" title={
                                            <span style={{ fontSize: '16px', fontWeight: '500' }}>
                                                Mail: {stepData.email || 0},<br /> SMS: {stepData.sms || 0}, <br /> Whatsapp: {stepData.whatsapp || 0}
                                            </span>
                                        } arrow
                                            slotProps={{
                                                popper: {
                                                    modifiers: [
                                                        {
                                                            name: 'offset',
                                                            options: {
                                                                offset: [0, 10],
                                                            },
                                                        },
                                                    ],
                                                },
                                            }}
                                        >
                                            <StepLabel StepIconComponent={(props) => <CustomStepIcon {...props} index={step.index} data={step} />} />
                                        </Tooltip>
                                    ) : (
                                        <StepLabel StepIconComponent={(props) => <CustomStepIcon {...props} index={step.index} data={step} />} />
                                    )}
                                    {/* <StepLabel StepIconComponent={(props) => <CustomStepIcon {...props} index={step.index} data={step} />} /> */}
                                    <div className="text-center" style={{ marginTop: '10px' }}>
                                        {/* {step.label === 'NotApproved' ? (
                                    <>
                                        1<sup>st</sup> Level Rejection
                                    </>
                                ) : step.label === 'Thanks' ? (
                                    <>
                                        Complete
                                    </>
                                ) : (
                                    step.label
                                )} */}
                                        {step.label}
                                    </div>
                                </Step>
                            )
                        }) : ""}
                    </Stepper>
                </Box>
            </div>
        </div>
        <div className="row form-group">

            <div className="col-xs-6 text-left">
                {/* {admin && admin.rolelist.indexOf(ROLE.DASHBOARD_REPORT_NEW) >= 0 ?
                    <Workbook filename="ApplicationStatus.xlsx" element={<button className="profile-save-btn margin-0"><span className="fa fa-download"></span>&nbsp;&nbsp;Excel</button>}>
                        <Workbook.Sheet data={allUserDetail} name="Sheet A">
                            <Workbook.Column label="firstName" value="firstName" />
                            <Workbook.Column label="emailId" value="emailId" />
                            <Workbook.Column label="mobileNumber" value="mobileNumber" />
                            <Workbook.Column label="panNumber" value="panNumber" />
                            <Workbook.Column label="formStatus" value="formStatus" />
                        </Workbook.Sheet>
                    </Workbook>
                    : ""} */}
            </div>
            <div className="col-xs-6 text-right">
                {/* <button className="admin-pagination-btn" id="backword" onClick={e => backpage()}><span className="fa fa-chevron-left" /></button>
                <button className="admin-pagination-btn" id="forword" onClick={e => forwordpage()}><span className="fa fa-chevron-right" /></button> */}
                {/* <p>1-100</p> */}
            </div>
        </div>
        <div className="row" style={{ marginTop: '20px' }}>
            <div className="col-xs-12 no-padding overflow-auto">
                {loadarState == false ?
                    allUserDetail != null ? allUserDetail.length > 0 ?
                        <table className='phocket-table'>
                            <thead>
                                <tr>
                                    <td>Form Step</td>
                                    
                                    <td>First Name</td>
                                    <td>Mobile Verified</td>
                                    <td style={{ minWidth: '80px' }}><i class="fa fa-star" aria-hidden="true" style={{ color: '#ffa534' }}></i></td>
                                    <td>Email Id</td>
                                    <td>Login Date</td>
                                    <td>State</td>
                                    <td>Phone Number</td>
                                    {admin && admin.rolelist.indexOf(ROLE.EDIT) >= 0 ?

                                        <td>Edit</td>
                                        : ""}
                                    {admin && admin.emailId === 'SuperUser' ?
                                        <td>Unsubscribe</td>
                                        : ""}
                                    <td>User Id</td>
                                    <td>Created At</td>
                                    <td>Alternate Number Verified At</td>
                                    <td>Logs</td>
                                    <td>Reset OTP Limit</td>
                                    {admin && admin.emailId === 'SuperUser' ?
                                        <td>Delete</td>
                                        : ""}
                                    {admin && admin.emailId === 'SuperUser' ?
                                        <td>Verify</td>
                                        : ""}

                                </tr>
                            </thead>

                            <tbody>
                                {allUserDetail && allUserDetail.slice(tableMinPagination, tableMaxPagination).map((data, i) => {
                                    return (
                                        <tr>
                                            <td>{data.formStatus}</td>
                                            
                                            <td> {data.firstName}</td>
                                            <td> <div style={{ textAlign: 'center' }}>
                                                {data.mobileVerified === true || data.mobileVerified === 'true' ?
                                                    <i class="fa fa-check" style={{ color: 'green' }}></i>
                                                    :
                                                    <i class="fa fa-close" style={{ color: 'red' }}></i>
                                                }
                                            </div></td>
                                            <td style={{ cursor: 'pointer' }}>{data?.important ? <i class="fa fa-star" aria-hidden="true" onClick={() => MarkAsImportant(false, data)} style={{ color: '#ffa534' }}></i> : <i class="fa fa-star-o" aria-hidden="true" onClick={() => MarkAsImportant(true, data)}></i>}</td>
                                            <td>{data.emailId}</td>
                                            <td>{data?.loginDate || "-"}</td>
                                            <td>{data.state}</td>
                                            <td>{data.mobileNumber}</td>
                                            {admin && admin.rolelist.indexOf(ROLE.EDIT) >= 0 ?

                                                <td><button onClick={e => editUserHandler(data,"edit")}><span className="fa fa-pencil-square-o" /></button></td>
                                                : ""}
                                            {admin && admin.emailId === 'SuperUser' ?
                                                <td> <button className="unsubscribe-btn" onClick={e => unsubscribeHandler(data.userId)}>Unsubscribe</button></td> : ""}
                                            <td>{data.userId}</td>
                                            <td>{data?.createdDate || "-"}</td>
                                            <td>{data?.altNumberVerified || "-"}</td>
                                            <td><img src={LogsInactive} style={{ width: '27px', cursor: 'pointer' }} onClick={() => handleCommLogsPopup(true, data)} /></td>
                                            <td><button className="btn btn-primary" onClick={()=>handleResend(data?.mobileNumber)}>Resend</button></td>
                                            {admin && admin.emailId === 'SuperUser' ?
                                                <td> <button onClick={e => deleteUserHandler(data.userId)}><span className="fa fa-trash" /></button></td> : ""}
                                            {admin && admin.emailId === 'SuperUser' ?
                                                <td> <button onClick={e => varifyMobile(data.userId)}><span className="fa fa-save" /></button></td> : ""}

                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>


                        : "" : "" :
                    <DotLoader />}

            </div>
            {!loadarState ?
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-2 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" id="backword" onClick={e => paginationHandler('left')}><span className="fa fa-chevron-left" /></button></div>
                        <div className="col-sm-3 col-xs-12 no-padding"><button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block red  " onClick={e => phocketTablePagination(allUserDetail, 'back')}></button></div>
                        <div className="col-sm-2 col-xs-12  phoc text-center" >{(tableMinPagination + 1) + ' - ' + (tableMaxPagination) + ' of ' + allUserDetail.length}</div>
                        <div className="col-sm-3 col-xs-12 no-padding" ><button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block red" onClick={e => phocketTablePagination(allUserDetail, 'forward')}></button></div>
                        <div className="col-sm-2 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" id="forword" onClick={e => paginationHandler('right')}><span className="fa fa-chevron-right" /></button></div> </div>
                </div>
                : ""}

            {
                commPopupData.show ?
                    <div className="background-blur">

                        <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: 'auto' }}>
                            <i onClick={() => handleCommLogsPopup(false, {})} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                            <div>
                                <h4 className='text-center'>{commPopupData?.dataValue?.firstName + " " + commPopupData?.dataValue?.lastName}</h4>
                            </div>
                            <div className="row" style={{ marginTop: '30px' }}>
                                <div className="col-sm-12 btn-group btn-grp-own-logs">
                                    <button className="btn btn-outline-primary" style={{ borderTopLeftRadius: '12px', borderBottomLeftRadius: '12px', background: PopupViewTab === 'communication' ? '#1D3557' : '#F1F7FF', color: PopupViewTab === 'communication' ? '#fff' : '#000', zIndex: 0, width: 'calc(100%/3)' }} onClick={() => PopupbuttonHandle('communication')}>  Logs </button>
                                    <button className="btn btn-outline-primary" style={{ background: PopupViewTab === 'communicationLogs' ? '#1D3557' : '#F1F7FF', color: PopupViewTab === 'communicationLogs' ? '#fff' : '#000', zIndex: 0, width: 'calc(100%/3)' }} onClick={() => PopupbuttonHandle('communicationLogs')}> Communication Logs </button>

                                    <button className="btn btn-outline-primary" style={{ borderTopRightRadius: '12px', borderBottomRightRadius: '12px', background: PopupViewTab === 'comment' ? '#1D3557' : '#F1F7FF', color: PopupViewTab === 'comment' ? '#fff' : '#000', zIndex: 0, width: 'calc(100%/3)' }} onClick={() => PopupbuttonHandle('comment')} >Comments </button>
                                </div>
                            </div>
                            {
                                PopupViewTab === 'comment' ?
                                    <>
                                        {
                                            showPopupTabsValue?.commentOption == false ?
                                                <div className="row from-group" >
                                                    <div className="col-xs-12" style={{ padding: '10px', margin: '20px 0' }}>
                                                        <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => HandlePopupAddBtn("comment", "open")}><i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Comment</button>
                                                    </div>
                                                </div>
                                                : ''}
                                        {
                                            showPopupTabsValue?.commentOption == true ?
                                                <>
                                                    <div className="row from-group" style={{ marginTop: '30px' }}>
                                                        <div className="col-xs-12" style={{ padding: '10px' }}>
                                                            <h4 className="" style={{ marginBottom: '10px', marginTop: '10px' }}>Add Comment</h4>
                                                        </div>
                                                    </div>
                                                    {console.log("RemarksListData", RemarksListData)}
                                                    {
                                                        RemarksListData && RemarksListData?.length > 0 ?
                                                            <div className="row from-group" >
                                                                <div className="col-sm-3 col-xs-12">
                                                                    <select className='form-control' value={RemarksType} onChange={(e) => handleRemarkType(e)}>
                                                                        <option value="">Select Comment</option>
                                                                        {
                                                                            RemarksListData?.map((value) => (
                                                                                <option value={value}>{value}</option>
                                                                            ))
                                                                        }
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            : ''}
                                                    {
                                                        RemarksType === "Custom Comment" ?
                                                            <div className="row from-group" style={{ marginTop: '30px' }}>
                                                                <div className="col-sm-12 col-xs-12">
                                                                    <textarea className='form-control' placeholder='type here...' onChange={(e) => AddCommentHandler(e)} />
                                                                </div>
                                                            </div>
                                                            : ''}
                                                    {
                                                        RemarksType !== "" ?
                                                            <>
                                                                <div className="row from-group text-center" >
                                                                    <div className="col-xs-12">
                                                                        <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF', marginRight: '10px' }} onClick={() => HandlePopupAddBtn("comment", "close")}>Close</button>
                                                                        <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => SaveCommentInPopup()}>Add</button></div>
                                                                </div>
                                                            </>
                                                            : ''}
                                                    <hr style={{ margin: '20px 0' }} />
                                                </>
                                                : ''}

                                        <div style={{ height: '250px', overflowY: 'auto', marginTop: '30px' }}>
                                            <table className='phocket-table'>
                                                <thead style={{ position: 'sticky', top: "0" }}>
                                                    <tr>
                                                        <td>Comment</td>
                                                        <td>Added By</td>
                                                        <td>Added At</td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {commentData && commentData?.commentList?.length > 0 && commentData?.commentList?.map((data, i) => {
                                                        return (
                                                            <tr>
                                                                <td>{data?.comment || "-"}</td>
                                                                <td> {data?.commentBy || "-"} </td>
                                                                <td> {data?.addedAt || "-"} </td>

                                                            </tr>
                                                        )
                                                    })}

                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                    : ''}
                            {
                                PopupViewTab === 'communication' ?
                                    <>
                                        {
                                            showPopupTabsValue?.callOption == false ?
                                                <div className="row from-group" >
                                                    <div className="col-xs-12" style={{ padding: '10px', margin: '20px 0' }}>
                                                        <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} onClick={() => HandlePopupAddBtn("call", "open")}><i class="fa fa-plus" aria-hidden="true"></i>&nbsp; Communication Details</button>
                                                    </div>
                                                </div>
                                                : ''}
                                        {
                                            showPopupTabsValue?.callOption == true ?
                                                <>
                                                    <div className="row from-group" style={{ marginTop: '30px' }}>
                                                        <div className="col-xs-12" style={{ padding: '10px' }}>
                                                            <h4 className="" style={{ marginBottom: '10px', marginTop: '10px' }}>Add Communication Details</h4>
                                                        </div>
                                                    </div>
                                                    <div className="row from-group" >
                                                        <div className="col-sm-3 col-xs-12">
                                                            <select className='form-control' value={communicationDetailType} onChange={(e) => handlecommunicationDetailTypechange(e)}>
                                                                <option value="">Select Communication Type</option>
                                                                <option value="mail">Mail</option>
                                                                <option value="call">Call</option>
                                                                <option value="sms">SMS</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row from-group" style={{ marginTop: '30px' }}>
                                                        <div className="col-sm-12 col-xs-12" >
                                                            <textarea className='form-control' placeholder='type here...' onChange={(e) => AddCallDetailHandler(e)} />
                                                        </div>
                                                    </div>
                                                    <div className="row from-group text-center">
                                                        <div className="col-xs-12">
                                                            <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF', marginRight: '10px' }} onClick={() => HandlePopupAddBtn("call", "close")}>Close</button>
                                                            <button className="btn btn-primary" style={{ marginTop: '20px', borderRadius: '5px', border: '1px solid #D3D9E9', boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)', background: '#2B78FF' }} disabled={communicationDetailType == "" || communicationDetailType == undefined || communicationDetailType == null ? true : false} onClick={() => SaveCallDetailInPopup()}>Add</button></div>
                                                    </div>
                                                    <hr style={{ margin: '20px 0' }} />
                                                </>
                                                : ''}
                                        <div style={{ height: '250px', overflowY: 'auto' }}>
                                            <table className='phocket-table' >
                                                <thead style={{ position: 'sticky', top: "0" }}>
                                                    <tr>
                                                        <td>Employee ID</td>
                                                        <td>Communication Type</td>
                                                        <td>Communication Message</td>
                                                        <td>Form Status</td>
                                                        <td>Added At</td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {communicationList && communicationList?.length > 0 && communicationList?.map((data, i) => {
                                                        return (
                                                            <tr>
                                                                <td>{data?.empId || "-"}</td>
                                                                <td> {data?.communicationType || "-"} </td>
                                                                <td> {data?.body || "-"} </td>
                                                                <td> {data?.formStatus || "-"} </td>
                                                                <td> {data?.createdAt || "-"} </td>

                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                    : ''}
                            {
                                PopupViewTab === 'communicationLogs' ?
                                    <>
                                        <div className="row" style={{ margin: '20px 0' }}>
                                            <div className="col-sm-2 col-xs-12">
                                                <label htmlFor="">Filter</label>
                                                <select className='form-control' value={commList?.commType} onChange={(e) => handlecommMain(e, "commType")}>
                                                    <option value="">Select Communication Type</option>
                                                    <option value="EMAIL">Mail</option>
                                                    <option value="SMS">SMS</option>
                                                    <option value="WHATSAPP">Whatsapp</option>
                                                    <option value="CALL">Call</option>
                                                </select>
                                            </div>
                                            <div className="col-sm-2 col-xs-12">
                                                <label htmlFor="">Start Date</label>
                                                <input type="date" className='form-control' value={commList?.startDate} onChange={(e) => handlecommMain(e, "startDate")} />
                                            </div>
                                            <div className="col-sm-2 col-xs-12">
                                                <label htmlFor="">End Date</label>
                                                <input type="date" className='form-control' value={commList?.startDate} onChange={(e) => handlecommMain(e, "startDate")} />
                                            </div>
                                            <div className="col-sm-2 col-xs-12">
                                                <button className='btn btn-primary' onClick={() => GetCommunicationLogsMain(0)} style={{ marginTop: '22px', padding: '10px' }}>Apply Filter</button>
                                            </div>
                                        </div>
                                        <div style={{ height: '250px', overflowY: 'auto' }}>
                                            <table className='phocket-table' >
                                                <thead style={{ position: 'sticky', top: "0" }}>
                                                    <tr>
                                                        <td>user ID</td>
                                                        <td>Communication Type</td>
                                                        <td>Message</td>
                                                        <td>Form Status</td>
                                                        <td>Added At</td>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {commList && commList?.ListData?.length > 0 && commList?.ListData?.map((data, i) => {
                                                        return (
                                                            <tr>
                                                                <td>{data?.userId || "-"}</td>
                                                                <td> {data?.communicationType || "-"} </td>
                                                                <td> <i className='fa fa-eye' onClick={() => handlePreview(true, data)}></i> </td>
                                                                <td> {data?.formStatus || "-"} </td>
                                                                <td> {formatDateLatest(data?.addedAt) || "-"} </td>

                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>

                                        {
                                            showCommServiceDataPreview?.show == true ?
                                                <div className="background-blur">
                                                    <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '600px', top: showCommServiceDataPreview?.data?.communicationType == "EMAIL" ? "5%" : '15%' }}>
                                                        {showCommServiceDataPreview?.data?.communicationType == "WHATSAPP" ?
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html: showCommServiceDataPreview?.data?.body
                                                                        ?.replace(/\n/g, '<br/>')
                                                                }}
                                                            />
                                                            :
                                                            showCommServiceDataPreview?.data?.communicationType == "SMS" ?
                                                                <div
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: showCommServiceDataPreview?.data?.body

                                                                    }}
                                                                />
                                                                :
                                                                showCommServiceDataPreview?.data?.communicationType == "EMAIL" ?
                                                                    <div style={{ height: '500px', overflowY: 'auto' }}
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: showCommServiceDataPreview?.data?.body
                                                                        }}
                                                                    />
                                                                    : ''}

                                                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                                            <button className='btn btn-primary' onClick={() => handlePreview(false, {})}>Close</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                : ''}
                                    </>
                                    : ''}
                        </div>
                    </div>
                    : ''}

                                        {
                                            ExcelDownloadData?.show ?
                                                <div className="background-blur">
                                                    <div className="popup-main small-popup container-fluid max-width-500px dbl-border " style={{ padding: '20px', borderRadius: '10px', width: '600px', top: '15%' }}>
                                                        <i onClick={() => handleDownloadExcelOption(false,"show")} style={{ float: "right", marginTop: '-18px', marginRight: '-17px', fontSize: '20px', color: 'red' }} className="fa fa-times-circle"></i>
                                                        <h4 className='text-center' style={{margin:'10px 0 20px 0'}}>Download Excel</h4>
                                                        <div className="row form-group">
                                                            <div className="col-sm-4 col-xs-12">
                                                                <label htmlFor="">Start Date</label>
                                                                <input type="date" className='form-control' value={ExcelDownloadData?.startDate} onChange={(e)=>handleDownloadExcelOption(e,"startDate")} />
                                                            </div>
                                                            <div className="col-sm-4 col-xs-12">
                                                                <label htmlFor="">End Date</label>
                                                                <input type="date" className='form-control' value={ExcelDownloadData?.endDate} onChange={(e)=>handleDownloadExcelOption(e,"endDate")} />
                                                            </div>
                                                            <div className="col-sm-4 col-xs-12">
                                                                <label htmlFor="">Report Type</label>
                                                                <select type="date" className='form-control' value={ExcelDownloadData?.dateType} onChange={(e)=>handleDownloadExcelOption(e,"dateType")} >
                                                                    <option value="formStatus">Form Status</option>
                                                                    <option value="comments">Comments</option>
                                                                    <option value="createdDate">Created Date</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                                                            <button className='btn btn-primary' onClick={() => handleDownloadExcel()}>Download</button>
                                                        </div>
                                                    </div>
                                                </div>
                                                : ''}

            {
                LogListPopup ?
                    <CommunicationDetailPopupAllApplications
                        handleLogListPopup={handleLogListPopup}
                    />
                    : ''}
            {/* {
                callPopup ?
                    <ExotelMain HandlecallPopup={HandlecallPopup} />
                    : ''} */}


        </div>
    </div>
)

export default ApplicationStatus;